import t from"./get-built-in.js";var e=t,m=e("document","documentElement");export{m as default};
